/**
 * percent.ts — a part of a whole as a whole percentage, the one way the portal
 * works one out: rounded, and 0 of nothing. The student's campaign cards, rows
 * and hero, every chapter's bar and the admin's import progress each worked it
 * out by hand.
 */

/** `part` of `whole` as a whole percentage: 20 of 255 is 8; 0 when the whole is 0. */
export const percentOf = (part: number, whole: number): number => (whole > 0 ? Math.round((part / whole) * 100) : 0);
